module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info"
  }, [_c('InfoIcon', {
    staticClass: "button"
  }), _vm._v(" "), _c('span', {
    staticClass: "tooltip-text"
  }, [_vm._t("default")], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-987d60e8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Info.vue
// module id = 688
// module chunks = 2